export default "__VITE_ASSET__e48f91b5__"